"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromiseLike = exports.isMapLike = exports.debounce = void 0;
var mobx_1 = require("mobx");
/**
 * Debounce
 */
var now = function () { return new Date().getTime(); };
function debounce(func, milliseconds, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout, args, context, timestamp, result;
    var wait = milliseconds;
    var later = function () {
        var last = now() - timestamp;
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last);
        }
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                if (!timeout)
                    context = args = null;
            }
        }
    };
    return function () {
        context = this;
        args = arguments;
        timestamp = now();
        var callNow = immediate && !timeout;
        if (!timeout)
            timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
}
exports.debounce = debounce;
function isMapLike(thing) {
    return mobx_1.isObservableMap(thing)
        || (typeof Map !== 'undefined' && thing instanceof Map);
}
exports.isMapLike = isMapLike;
function isPromiseLike(arg) {
    return arg != null && typeof arg === "object" && typeof arg.then === "function";
}
exports.isPromiseLike = isPromiseLike;
